import React from "react";
import CommunityList from "../../components/Community/CommunityList";

export default function PraiseList() {
  return (
    <CommunityList
      type="PRAISE"
      title="Praise and Miracle Reports"
      subtitle="Confirmed praise and miracle reports are shown publicly."
      createButtonText="Post a Praise and Miracle Reports"
      emptyStateEmoji="✨"
      emptyStateMessage="No new confirmed requests, Keep sharing your testimony!"
      emptyStateButtonText="Share your testimony"
    />
  );
}